import type { PreviewSchemaField } from "../../lib/api";

export interface Source {
  id: string;
  name: string;
  connectorId: string;
}

export type TabKey = "summary" | "datasets" | "containers" | "pipelines";

export interface TagDrawerInfo {
  field: PreviewSchemaField;
  assetName: string;
}

export const TAG_PILL_COLORS = [
  "bg-sky-50 text-sky-700 border border-sky-200",
  "bg-violet-50 text-violet-700 border border-violet-200",
  "bg-emerald-50 text-emerald-700 border border-emerald-200",
  "bg-amber-50 text-amber-700 border border-amber-200",
  "bg-rose-50 text-rose-700 border border-rose-200",
  "bg-indigo-50 text-indigo-700 border border-indigo-200",
  "bg-teal-50 text-teal-700 border border-teal-200",
  "bg-orange-50 text-orange-700 border border-orange-200",
] as const;
